import { render, staticRenderFns } from "./DashboardOficialesWeb.vue?vue&type=template&id=3d457ea2"
import script from "./DashboardOficialesWeb.vue?vue&type=script&lang=js"
export * from "./DashboardOficialesWeb.vue?vue&type=script&lang=js"
import style0 from "./DashboardOficialesWeb.vue?vue&type=style&index=0&id=3d457ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports